export default __webpack_public_path__ + "795474c9daf4edb3ae34cd2e1768bf28.png";